import PropTypes from 'prop-types';
import { formatDate, formatAmount } from 'Shared/util/formatters';
import DataTable, { ColumnTypes } from 'Shared/components/tables/data-table';
import { translateColumns, funcFilterStatus } from 'Shared/util/translations';
import { useTranslation } from 'Shared/util/custom-hooks';


const columns = [{
  title: 'paymentDate',
  key: 'date',
  type: ColumnTypes.Date,
  formatter: (d) => formatDate(d),
}, {
  title: 'type',
  key: 'description',
}, {
  title: 'amountPaid',
  key: 'transactionAmount',
  type: ColumnTypes.Amount,
  formatter: (d) => formatAmount(d),
}, {
  title: 'currency',
  key: 'currencyCode',
}];


const getRowLink = (row) => {
  if (row.invoiceGroupId > 0) {
    return `/invoice-groups/${row.invoiceGroupId}`;
  }
  if (row.depositionGroupId > 0) {
    return `/deposition-groups/${row.depositionGroupId}`;
  }
  return null;
};


const TransactionTable = ({
  rows,
  loading,
}) => {
  const t = useTranslation(x => x.transactions);
  return (
    <DataTable
      loading={loading}
      columns={translateColumns(columns, t)}
      rows={funcFilterStatus(rows, t, 'description')}
      getRowLink={getRowLink}
    />
  );
};

TransactionTable.propTypes = {
  rows: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

export default TransactionTable;
